module.exports = " <div class=cardList _v-77fb3918=\"\"> <slot _v-77fb3918=\"\"></slot> <card invisible=\"\" :wide=wide v-if=!simple _v-77fb3918=\"\"></card> <card invisible=\"\" :wide=wide v-if=\"!simple &amp;&amp; !wide\" _v-77fb3918=\"\"></card> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-77fb3918!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardList.vue
// module id = 325
// module chunks = 2